module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/assessment_achievements/3_67b2f9c6174e6961e51a1620c96502d2.jpg";